export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image with slow zoom */}
      <div className="absolute inset-0 animate-hero-zoom">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20dark%20dramatic%20cattle%20livestock%20farm%20at%20dusk%20dramatic%20blue%20black%20sky%20silhouetted%20cows%20herd%20volumetric%20fog%20moody%20atmospheric%20professional%20photography%20wide%20angle%20deep%20shadows%20blue%20black%20color%20palette&width=1920&height=1080&seq=hero1&orientation=landscape"
          alt="Hamva Pharmaceuticals livestock"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Multi-layer overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-dark-blue/60 to-dark/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-dark/50 via-transparent to-dark/30" />

      {/* Noise overlay */}
      <div
        className="absolute inset-0 pointer-events-none opacity-20"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.12'/%3E%3C/svg%3E")`,
        }}
      />

      {/* Glow effects */}
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-1/3 right-1/4 w-80 h-80 bg-dark-blue-alt/40 rounded-full blur-3xl pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-16">
        <div className="max-w-3xl">
          {/* Badge */}
          <div
            className="inline-flex items-center gap-2 glass rounded-full px-4 py-1.5 mb-8 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}
          >
            <span className="w-2 h-2 bg-accent rounded-full animate-pulse-red" />
            <span className="text-xs text-white/70 font-medium tracking-wider uppercase">
              Trusted by Farmers &amp; Distributors
            </span>
          </div>

          {/* Main headline */}
          <h1
            className="font-poppins font-bold leading-tight mb-4 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }}
          >
            <span className="block text-4xl md:text-6xl lg:text-7xl text-white">
              Advanced Animal Health
            </span>
            <span className="block text-4xl md:text-6xl lg:text-7xl text-white mt-1">
              <span className="text-accent relative inline-block">
                Solutions
                <span className="absolute bottom-0 left-0 h-1 bg-accent animate-expand-width rounded-full" />
              </span>
              {' '}for Stronger
            </span>
            <span className="block text-4xl md:text-6xl lg:text-7xl text-white mt-1">
              Livestock
            </span>
          </h1>

          {/* Subheadline */}
          <p
            className="text-text-soft text-lg md:text-xl leading-relaxed max-w-2xl mt-6 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.7s', animationFillMode: 'forwards' }}
          >
            Boost milk and meat production with high-performance veterinary solutions trusted by farmers across Pakistan.
          </p>

          {/* CTA Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-4 mt-10 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '0.9s', animationFillMode: 'forwards' }}
          >
            <a
              href="https://wa.me/923007321011"
              target="_blank"
              rel="noopener noreferrer"
              className="wa-btn inline-flex items-center justify-center gap-2.5 px-8 py-4 rounded-full text-base font-semibold text-white cursor-pointer whitespace-nowrap red-glow"
            >
              <i className="ri-whatsapp-line text-xl" />
              WhatsApp Us
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-base font-semibold text-white border border-white/30 hover:border-white/60 hover:bg-white/5 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </a>
          </div>

          {/* Stats */}
          <div
            className="flex flex-wrap gap-4 mt-14 opacity-0 animate-fade-in-up"
            style={{ animationDelay: '1.1s', animationFillMode: 'forwards' }}
          >
            {[
              { value: '500+', label: 'Products' },
              { value: '25%', label: 'Avg. Milk Increase' },
              { value: '15+', label: 'Years Trust' },
            ].map((stat) => (
              <div
                key={stat.label}
                className="glass rounded-2xl px-6 py-4 min-w-[130px]"
              >
                <p className="font-poppins font-bold text-2xl text-accent">{stat.value}</p>
                <p className="text-xs text-text-muted mt-0.5">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-50">
        <p className="text-xs text-white/50 tracking-widest uppercase">Scroll</p>
        <div className="w-px h-10 bg-gradient-to-b from-white/40 to-transparent" />
      </div>
    </section>
  );
}
